import React from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for animations
const scrolldownAnim = keyframes`
  0% {
    opacity: 0;
    height: 6px;
  }
  40% {
    opacity: 1;
    height: 10px;
  }
  80% {
    transform: translate(0, 20px);
    height: 10px;
    opacity: 0;
  }
  100% {
    height: 3px;
    opacity: 0;
  }
`;

const pulse = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
`;

// Styled components
const ScrollDownContainer = styled.div`
    position: relative;
    width: 30px;
    height: 50px;
    margin-left: 15px;
    border: 3px solid ${(props) => props.color || "skyblue"};
    border-radius: 50px;
    box-sizing: border-box;
    margin-bottom: 16px;
    cursor: pointer;
    background: ${(props) => props.bgColor || "transparent"};

    &::before {
        content: "";
        position: absolute;
        bottom: 30px;
        left: 50%;
        width: 6px;
        height: 6px;
        margin-left: -3px;
        background-color: ${(props) => props.color || "skyblue"};
        border-radius: 100%;
        animation: ${scrolldownAnim} 2s infinite;
        box-sizing: border-box;
        box-shadow: 0px -5px 3px 1px #2a547066;
    }
`;

const Chevrons = styled.div`
    padding: 6px 0 0 0;
    margin-left: -3px;
    margin-top: 48px;
    width: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ChevronDown = styled.div`
    margin-top: -6px;
    position: relative;
    border: solid ${(props) => props.color || "skyblue"};
    border-width: 0 3px 3px 0;
    display: inline-block;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    animation: ${pulse} 500ms ease infinite alternate;

    &:nth-child(even) {
        animation-delay: 250ms;
    }
`;

const ScrollDown = ({ color = "skyblue", bgColor = "transparent" }) => (
    <ScrollDownContainer color={color} bgColor={bgColor}>
        <Chevrons>
            <ChevronDown />
            <ChevronDown />
        </Chevrons>
    </ScrollDownContainer>
);

export default ScrollDown;
